<template>
    <section id="about" class="pt-130">
    <div class="about_area">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="about_content pt-120 pb-130">
              <div class="section_title pb">
                <h4
                  class="title wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.2s"
                >
                  Quem Somos
                </h4>
                <p
                  class="wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.4s"
                >
                  A maneira mais fácil de começar é contando a história de como
                  sua empresa nasceu. Isso funciona bem quando levou um tempo
                  para acontecer, mesmo se é uma marca recente.
                </p>
                <p
                  class="wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.6s"
                >
                  Comece com os fundadores originais e as suas razões para
                  começar o negócio.
                </p>
              </div>
              <!--<a
                href="#"
                class="main-btn wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.7s"
                >Saiba Mais</a
              >-->
            </div>
          </div>
        </div>
      </div>
      <div
        class="about_image bg_cover wow fadeInLeft"
        data-wow-duration="1.3s"
        data-wow-delay="0.2s"
      >
      <img style="margin-top:10%; margin-left:10%" src="assets/images/CDGsize50.png">
        <!-- 
        <div class="image_content">
          <h4 class="experience"><span>5</span> Years of Experience</h4>
        </div>
        -->
      </div>
    </div>
  </section>

</template>

<script>
export default {
  //props: ['textconteudo', 'icon', 'title'],
};
</script>

<style scoped>

</style>